export const DEFAULT_ACCORDION = 'General';
